import * as Scrivito from "scrivito";
import { useEffect } from "react";
import {
  useProjectError,
  useProjectActions,
} from "stores/project/project/projectStore";
import { useIsSameProj } from "stores/globalStore";

export const useRedirectOnError = () => {
  const error = useProjectError();
  const { clear: clearProject } = useProjectActions();
  const isSameProj = useIsSameProj();

  const projectList = Scrivito.Obj.where(
    "_objClass",
    "equals",
    isSameProj ? "ProjectListSame" : "ProjectList",
  ).first();

  useEffect(() => {
    if (error && projectList) {
      clearProject();
      Scrivito.navigateTo(projectList);
    }
  }, [error, projectList, clearProject]);
};
